<template>
    <thead class="sortable">
        <tr>
            <td v-for="(row, idx) in value" :class="getTdClasses(row.classes, row.sorting)">
                <a v-if="row.sorting" class="header-content" @click.prevent="toggleSorting(idx)">
                    <span v-if="row.sorting.value == 0">
                        {{ row.label }}
                        <i aria-hidden="true" class="fa fa-sort"></i>
                    </span>
                    <span v-else class="has-icons">
                        <span>{{ row.label }}</span>
                        <i aria-hidden="true" class="fa" :class="'fa-sort-' + (row.sorting.value == 1 ? 'desc': 'asc')"></i>
                    </span>
                </a>
                <span v-else>{{ row.label }}</span>
            </td>
        </tr>
    </thead>
</template>


<script>
    import {cloneDeep} from 'lodash';

    export default {
        name: 'sortable-table-head',

        props: {
            value: {
                type: Array,
                'default': () => ([]),
            },
        },

        methods: {
            toggleSorting(idx) {
                let val = cloneDeep(this.value);

                for(let i = 0; i < val.length; i++) {
                    if(val[i].sorting) {
                        if(i !== idx) {
                            val[i].sorting.value = 0;
                        } else {
                            if(val[i].sorting.value === 0) {
                                val[i].sorting.value = 1;
                            } else {
                                val[i].sorting.value *= -1;
                            }
                        }
                    }
                }

                this.$emit('input', val);
            },

            getTdClasses(baseClasses, sorting) {
                if(!baseClasses) {
                    baseClasses = [];
                }
                let activeClass = [];
                if(!!sorting && Number(sorting.value) !== 0) {
                    activeClass = ['is-active'];
                }
                return [...baseClasses, ...activeClass];
            }
        },
    };
</script>

<style lang="scss">
    @import 'sortable-table-head.scss';
</style>



// WEBPACK FOOTER //
// src/views/components/tables/sortable-table-head.vue